import React, { useState } from 'react'
import PasswordUpdateForm from '../auth/PasswordUpdateForm';
import UserDeleteModal from '../auth/UserDeleteModal';

function PasswordSettings() {
    const [activeTab, setActiveTab] = useState(0)

    const tabs = [
        "Update Password",
        "Account Management"
    ];
    return (
        <div className='p-3 py-4 space-y-5'>
            <div className="">
                <h3 className="text-xl font-bold text-gray-800">
                    Security
                </h3>
                <p className="text-zinc-500 mt-1">Update your current password or delete your account.</p>
            </div>
            <hr />
            <div className="flex justify-center">
                <div className="">
                    <div className="tabs tabs-boxed justify-center">
                        {tabs.map((tab, idx) => (
                            // eslint-disable-next-line jsx-a11y/anchor-is-valid
                            <a
                                key={idx}
                                className={`tab ${activeTab === idx ? 'tab-active bg-primary text-white rounded-lg' : ''}`}
                                onClick={() => setActiveTab(idx)}
                                role="tab"
                                aria-selected={activeTab === idx}
                            >
                                {tab}
                            </a>
                        ))}
                    </div>
                </div>
            </div>

            <div className="">
                {activeTab === 0 && (
                    <div>
                        <PasswordUpdateForm />
                    </div>
                )}

                {activeTab === 1 && (
                    <div className="bg-surface-light dark:bg-surface-dark rounded-xl border border-border-light dark:border-border-dark hover:shadow-md space-y-5">
                        <div className="p-6 md:p-8">
                            <UserDeleteModal />
                            <div className="border-l-4 border-error pl-4 py-4">
                                <h3 className="font-bold text-error text-lg">Danger Zone</h3>
                                <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
                                    Deleting your account will permanently erase all your data.
                                    This action cannot be undone.
                                </p>
                                <div className="pt-4">
                                    <button
                                        className="mt-4 flex items-center space-x-2 bg-error text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-error/90 transition-colors"
                                        onClick={() => {
                                            const modal = document.getElementById('user-delete-modal');
                                            if (modal) modal.checked = true;
                                        }}
                                    >
                                        Delete Account
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default PasswordSettings